"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationTypeChoices = exports.DeadlineUrgencyChoices = exports.LocalStorageKeys = void 0;
var moment = require("moment");
var LocalStorageKeys = (function () {
    function LocalStorageKeys() {
    }
    LocalStorageKeys.accordionElements = "riskAccordionElements";
    return LocalStorageKeys;
}());
exports.LocalStorageKeys = LocalStorageKeys;
var DeadlineUrgencyChoices = (function () {
    function DeadlineUrgencyChoices() {
    }
    DeadlineUrgencyChoices.checkDeadline = function (date) {
        if (date.isBefore(moment(new Date()).add(this.EXPIRED_DATE_OFFSET, 'days')))
            return this.EXPIRED;
        else if (date.isBefore(moment(new Date()).add(this.CLOSE_DATE_OFFSET, 'days')))
            return this.CLOSE;
        return this.NORMAL;
    };
    DeadlineUrgencyChoices.EXPIRED = "expired";
    DeadlineUrgencyChoices.CLOSE = "upcoming";
    DeadlineUrgencyChoices.NORMAL = "";
    DeadlineUrgencyChoices.EXPIRED_DATE_OFFSET = 0;
    DeadlineUrgencyChoices.CLOSE_DATE_OFFSET = 14;
    return DeadlineUrgencyChoices;
}());
exports.DeadlineUrgencyChoices = DeadlineUrgencyChoices;
var EvaluationTypeChoices = (function () {
    function EvaluationTypeChoices() {
    }
    EvaluationTypeChoices.toList = function () {
        return [
            EvaluationTypeChoices.ALL,
            EvaluationTypeChoices.GROSS,
            EvaluationTypeChoices.PRESENT,
            EvaluationTypeChoices.NETT,
        ];
    };
    EvaluationTypeChoices.asDict = function () {
        var dict = {};
        dict[EvaluationTypeChoices.ALL] = gettext("all");
        dict[EvaluationTypeChoices.GROSS] = get_term("gross");
        dict[EvaluationTypeChoices.PRESENT] = get_term("present");
        dict[EvaluationTypeChoices.NETT] = get_term("nett");
        return dict;
    };
    EvaluationTypeChoices.display = function (code) {
        return EvaluationTypeChoices.asDict()[code];
    };
    EvaluationTypeChoices.ALL = 0;
    EvaluationTypeChoices.GROSS = 10;
    EvaluationTypeChoices.PRESENT = 20;
    EvaluationTypeChoices.NETT = 30;
    return EvaluationTypeChoices;
}());
exports.EvaluationTypeChoices = EvaluationTypeChoices;
